import React from 'react';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

import messages from './simulatedCorrectionFinishConfirmationModalMessages';

function SimulatedFinishConfirmationModal(props) {
  return (
    <Modal
      show={props.show}
      onClose={props.onClose}
      icon="ti ti-thumbs-up"
      title={props.intl.formatMessage(messages.title)}
      subtitle={props.intl.formatMessage(messages.subtitle)}
      buttons={[
        {
          label: props.intl.formatMessage(messages.cancel),
          onClick: props.onClose,
        },
        {
          label: props.intl.formatMessage(messages.accept),
          onClick: props.onAccept,
          primary: true,
        },
      ]}
    />
  );
}

SimulatedFinishConfirmationModal.defaultProps = {};

export default injectIntl(SimulatedFinishConfirmationModal);
